import { Navigate, Outlet, useLocation } from "react-router-dom";
import PlanExpiredBlockedPopup from "../../components/PlanExpiredBlockedPopup";
import { usePrivateRoute } from "../hooks/usePrivateRoute";

const Private = () => {
  const location = useLocation();
  const {
    isAuthenticated,
    shouldBlockForExpiredPlan,
    shouldRedirectToAdminUsers,
  } = usePrivateRoute(location);

  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  if (shouldRedirectToAdminUsers) {
    return <Navigate to="/admin-user" replace />;
  }

  if (shouldBlockForExpiredPlan) {
    return <PlanExpiredBlockedPopup />;
  }

  return <Outlet />;
};

export default Private;
